import script from "./PatientClinicianList.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientClinicianList.vue?vue&type=script&setup=true&lang=js"

import "./PatientClinicianList.vue?vue&type=style&index=0&id=3f786e86&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f786e86"]])

export default __exports__